import styled from "styled-components";

const Title = styled.h2`
  font-weight: bold;
  color: #222;
  margin: 10px 0 0 0;
  text-transform: lowercase;
  font-size: 20px;

  @media (max-width: 1599px) {
    font-size: 20px;
  }
  @media (max-width: 1199.98px) {
    font-size: 16px;
  }
  @media (max-width: 575px) {
    line-height: normal;
    text-align:left;    
  }
`;
export default Title;
